import script from "./StakingDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./StakingDetails.vue?vue&type=script&setup=true&lang=ts"

import "./StakingDetails.vue?vue&type=style&index=0&id=ac019484&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac019484"]])

export default __exports__